import React from 'react';
import { connect } from 'react-redux';

import PropTypes from 'prop-types';
import * as userTypes from '../../../redux/futures/user/types';
import Input from '../../../components/Input';
import _ from 'lodash';

class DeleteAiCall extends React.Component {
    static propTypes = {
        currentUser: PropTypes.object,
        deleteAiCall: PropTypes.func,
        user: PropTypes.object
    }

    constructor(props) {
        super(props);
        this.state = {
            currentUser: {
                _id: "",
                email: "",
                fullname: ""
            },
            formData: {
                acc_campaign_id: ""
            },
            loading: false,
            classNormal: "ladiui button danger",
            classLoading: "ladiui loader button danger",
            classApply: "ladiui button danger"
        };
        this.inputsRef = new Set();
        this.ref = React.createRef();
    }

    componentDidMount() {
        // Initialize component
    }

    componentDidUpdate() {
        window.LadiUI.init();
    }

    componentWillReceiveProps(nextProps) {
        if (this.props !== nextProps) {
            if (nextProps.currentUser && this.state.currentUser !== nextProps.currentUser && nextProps.currentUser._id && nextProps.currentUser._id !== "") {
                this.setState({
                    currentUser: nextProps.currentUser
                });
            }

            if (nextProps.user.action === userTypes.DELETE_AI_CALL) {
                this.setState({
                    loading: false,
                    classApply: this.state.classNormal
                });

                if (nextProps.user.status) {
                    const _self = this;
                    window.LadiUI.toastr('success', '', nextProps.user.message);
                    setTimeout(function () {
                        window.LadiUI.closeModal(_self.ref.current);
                        _self.resetForm();
                    }, 1000);
                } else {
                    window.LadiUI.toastr('error', '', nextProps.user.message);
                }
            }
        }
    }

    onChangeInput = (event) => {
        this.setState({
            formData: {
                ...this.state.formData,
                [event.target.name]: event.target.value
            }
        });
    }

    submit = () => {
        // Validate
        let errors = [];
        const inputsRef = _.compact(Array.from(this.inputsRef));
        _.map(inputsRef, ref => {
            if (ref.validate) {
                errors = errors.concat(ref.validate());
            }
        });

        _.compact(errors);
        if (errors.length > 0) {
            const errorMessage = errors.join("<br/>");
            window.LadiUI.toastr('error', '', errorMessage);
            return;
        }

        const { formData, currentUser } = this.state;

        const jsonData = {
            ladi_uid: currentUser._id,
            acc_campaign_id: formData.acc_campaign_id
        };

        this.props.deleteAiCall(jsonData);

        this.setState({
            loading: true,
            classApply: this.state.classLoading
        });
    }

    resetForm = () => {
        this.setState({
            formData: {
                acc_campaign_id: ""
            }
        });
    }

    render() {
        const { formData, currentUser } = this.state;
        const title = 'Xóa AI Call: Xóa cấu hình AI Call cho người dùng';
        this.inputsRef = new Set();

        return (
            <div ref={this.ref} id="modal-delete-ai-call" className="ladiui-modal fade" tabIndex={-1} data-dismiss="modal-delete-ai-call">
                <div className="ladiui-modal-content">
                    <div className="ladiui-modal-header">
                        <button type="button" className="ladiui-close-modal" data-dismiss="modal-delete-ai-call">
                            <i className="ladi-icon icon-e-remove" data-dismiss="modal-delete-ai-call" />
                        </button>
                        <h3>{title}</h3>
                    </div>
                    <div className="ladiui-modal-body" style={{ overflow: "unset" }}>
                        <form>
                            <div className="ladiui-tab-content">
                                <div className="ladiui-row">
                                    <div className="col-50">
                                        <div className="ladiui form-group">
                                            <label className="ladiui-label">Email</label>
                                            <input
                                                name="email"
                                                className="ladiui input"
                                                value={currentUser.email}
                                                disabled="disable"
                                            />
                                        </div>
                                    </div>
                                    <div className="col-50">
                                        <div className="ladiui form-group">
                                            <label className="ladiui-label">Họ tên</label>
                                            <input
                                                name="fullname"
                                                className="ladiui input"
                                                value={currentUser.fullname}
                                                disabled="disable"
                                            />
                                        </div>
                                    </div>
                                </div>

                                <div className="ladiui-row">
                                    <div className="col-100">
                                        <div className="ladiui form-group">
                                            <label className="ladiui-label">Acc Campaign ID</label>
                                            <Input
                                                ref={(ref) => this.inputsRef.add(ref)}
                                                name="acc_campaign_id"
                                                validationName="Acc Campaign ID"
                                                placeholder="Nhập Acc Campaign ID cần xóa"
                                                value={formData.acc_campaign_id}
                                                onChange={this.onChangeInput}
                                                validations={{ isRequired: true }}
                                            />
                                        </div>
                                    </div>
                                </div>

                                <div className="ladiui form-group">
                                    <div className="ladiui alert warning">
                                        <i className="ladi-icon icon-warning" style={{ marginRight: '8px' }} />
                                        <strong>Cảnh báo:</strong> Hành động này sẽ xóa hoàn toàn cấu hình AI Call. Bạn có chắc chắn muốn tiếp tục?
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                    <div className="ladiui-modal-footer">
                        <button className="ladiui button secondary close-modal icon" data-dismiss="modal-delete-ai-call">
                            <i className="ladi-icon icon-e-remove" data-dismiss="modal-delete-ai-call" />Đóng
                        </button>
                        <button
                            ref={this.ref}
                            className={this.state.classApply}
                            onClick={this.submit}
                            disabled={this.state.loading}
                        >
                            <i className="ladi-icon icon-trash" style={{ display: (this.state.loading) ? 'none' : '', paddingRight: '5px' }}></i>
                            Xóa AI Call
                        </button>
                    </div>
                </div>
            </div>
        );
    }
}


const mapStateToProps = (state) => ({ user: { ...state.user } });

export default connect(mapStateToProps)(DeleteAiCall);